// updated at: 2020-07-08T11:56:55.775Z

/* eslint-disable */
module.exports = {
  "Account": {
    "abi": [{
      "inputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "constructor"
    }, {
      "payable": true,
      "stateMutability": "payable",
      "type": "fallback"
    }, {
      "constant": true,
      "inputs": [],
      "name": "registry",
      "outputs": [{
        "internalType": "address",
        "name": "",
        "type": "address"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address payable",
        "name": "_recipient",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_data",
        "type": "bytes"
      }],
      "name": "executeTransaction",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }],
    "addresses": {},
    "byteCodeHash": "0x98e0b6facfcd413802cfdac35b5e06c10fed073bb6def81c59ee9152d10516f5"
  },
  "AccountExternalDeposit": {
    "abi": [{
      "inputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "constructor"
    }, {
      "payable": true,
      "stateMutability": "payable",
      "type": "fallback"
    }, {
      "constant": true,
      "inputs": [],
      "name": "registry",
      "outputs": [{
        "internalType": "address",
        "name": "",
        "type": "address"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }],
      "name": "pullout",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }],
    "addresses": {},
    "byteCodeHash": "0x31310974c8e7a274d61fb4f371641d8c59834b1e1a05a05ec6a298fbfc6325fe"
  },
  "AccountRegistry": {
    "abi": [{
      "inputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "constructor"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "authKey",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "enum AccountRegistryCore.AccountAuthKeyKinds",
        "name": "kind",
        "type": "uint8"
      }],
      "name": "AccountAuthKeyUpdated",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }],
      "name": "AccountDeployed",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }],
      "name": "AccountDepositMerged",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "token",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }],
      "name": "AccountDepositUpdated",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "token",
        "type": "address"
      }],
      "name": "AccountDepositWithdrawalCanceled",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "token",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "lockedUntil",
        "type": "uint256"
      }],
      "name": "AccountDepositWithdrawalRequested",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "token",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }],
      "name": "AccountDepositWithdrawn",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "sender",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "token",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "bytes32",
        "name": "uid",
        "type": "bytes32"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }],
      "name": "AccountPaymentChannelCommitted",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "recipient",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }, {
        "indexed": false,
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }],
      "name": "AccountTransactionExecuted",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "guardian",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "enum Guarded.GuardianStates",
        "name": "state",
        "type": "uint8"
      }],
      "name": "GuardianUpdated",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [],
      "name": "Initialized",
      "type": "event"
    }, {
      "payable": true,
      "stateMutability": "payable",
      "type": "fallback"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address",
        "name": "_sender",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }, {
        "internalType": "bytes32",
        "name": "_uid",
        "type": "bytes32"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_senderSignature",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_guardianSignature",
        "type": "bytes"
      }],
      "name": "commitAccountPaymentChannel",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address",
        "name": "_sender",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }, {
        "internalType": "bytes32",
        "name": "_uid",
        "type": "bytes32"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_senderSignature",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_guardianSignature",
        "type": "bytes"
      }],
      "name": "commitAccountPaymentChannelAndDeposit",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_saltKey",
        "type": "address"
      }],
      "name": "computeAccountAddresses",
      "outputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_accountExternalDeposit",
        "type": "address"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address payable",
        "name": "_recipient",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_data",
        "type": "bytes"
      }],
      "name": "executeAccountTransaction",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }],
      "name": "getAccount",
      "outputs": [{
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "bool",
        "name": "_deployed",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_authKey",
        "type": "address"
      }],
      "name": "getAccountAuthKey",
      "outputs": [{
        "internalType": "enum AccountRegistryCore.AccountAuthKeyKinds",
        "name": "_kind",
        "type": "uint8"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }],
      "name": "getAccountDeposit",
      "outputs": [{
        "internalType": "uint256",
        "name": "_externalAmount",
        "type": "uint256"
      }, {
        "internalType": "uint256",
        "name": "_internalAmount",
        "type": "uint256"
      }, {
        "internalType": "uint256",
        "name": "_withdrawalLockedUntil",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_sender",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }, {
        "internalType": "bytes32",
        "name": "_uid",
        "type": "bytes32"
      }],
      "name": "getAccountPaymentChannel",
      "outputs": [{
        "internalType": "uint256",
        "name": "_committedAmount",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "getChainId",
      "outputs": [{
        "internalType": "uint256",
        "name": "_result",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "pure",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_guardian",
        "type": "address"
      }],
      "name": "getGuardian",
      "outputs": [{
        "internalType": "enum Guarded.GuardianStates",
        "name": "_state",
        "type": "uint8"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "isInitialized",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }],
      "name": "moveFundsToAccountDeposit",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "bytes",
        "name": "_data",
        "type": "bytes"
      }, {
        "internalType": "address",
        "name": "_refundToken",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_refundAmount",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }],
      "name": "relayAccountOwnerCall",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "bytes",
        "name": "_data1",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data2",
        "type": "bytes"
      }, {
        "internalType": "address",
        "name": "_refundToken",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_refundAmount",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }],
      "name": "relayAccountOwnerCall2",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "bytes",
        "name": "_data1",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data2",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data3",
        "type": "bytes"
      }, {
        "internalType": "address",
        "name": "_refundToken",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_refundAmount",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }],
      "name": "relayAccountOwnerCall3",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "bytes",
        "name": "_data1",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data2",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data3",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data4",
        "type": "bytes"
      }, {
        "internalType": "address",
        "name": "_refundToken",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_refundAmount",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }],
      "name": "relayAccountOwnerCall4",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "bytes",
        "name": "_data1",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data2",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data3",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data4",
        "type": "bytes"
      }, {
        "internalType": "bytes",
        "name": "_data5",
        "type": "bytes"
      }, {
        "internalType": "address",
        "name": "_refundToken",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_refundAmount",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }],
      "name": "relayAccountOwnerCall5",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address",
        "name": "_authKey",
        "type": "address"
      }, {
        "internalType": "enum AccountRegistryCore.AccountAuthKeyKinds",
        "name": "_kind",
        "type": "uint8"
      }],
      "name": "setAccountAuthKey",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }],
      "name": "topUpAccountDeposit",
      "outputs": [],
      "payable": true,
      "stateMutability": "payable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address",
        "name": "_token",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_recipient",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_amount",
        "type": "uint256"
      }],
      "name": "transferAccountTokens",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_guardian",
        "type": "address"
      }, {
        "internalType": "enum Guarded.GuardianStates",
        "name": "_state",
        "type": "uint8"
      }],
      "name": "updateGuardian",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }, {
        "internalType": "bytes32",
        "name": "_messageHash",
        "type": "bytes32"
      }, {
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "enum AccountRegistryCore.AccountAuthKeyKinds",
        "name": "_requireAuthKeyKind",
        "type": "uint8"
      }],
      "name": "verifyAccountSignature",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }, {
        "internalType": "bytes32",
        "name": "_messageHash",
        "type": "bytes32"
      }],
      "name": "verifyGuardianSignature",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address payable",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address payable",
        "name": "_token",
        "type": "address"
      }],
      "name": "withdrawFromAccountDeposit",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "withdrawalLockPeriod",
      "outputs": [{
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address[]",
        "name": "_guardians",
        "type": "address[]"
      }, {
        "internalType": "uint256",
        "name": "_withdrawalLockPeriod",
        "type": "uint256"
      }],
      "name": "initialize",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }],
    "addresses": {
      "1": "0x8Fd7b08C4f54AdaBb80B14D246433B6CB8cd6579",
      "3": "0x8Fd7b08C4f54AdaBb80B14D246433B6CB8cd6579",
      "4": "0x8Fd7b08C4f54AdaBb80B14D246433B6CB8cd6579",
      "5": "0xC6Dd6624057D5E731fCc9288e93F47D156eC9de3",
      "42": "0x8Fd7b08C4f54AdaBb80B14D246433B6CB8cd6579",
      "100": "0x8Fd7b08C4f54AdaBb80B14D246433B6CB8cd6579",
      "4660": "0x8Fd7b08C4f54AdaBb80B14D246433B6CB8cd6579"
    },
    "byteCodeHash": null
  },
  "AccountFriendRecoveryExtension": {
    "abi": [{
      "inputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "constructor"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address[]",
        "name": "friends",
        "type": "address[]"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "requiredFriendSignatures",
        "type": "uint256"
      }],
      "name": "AccountConfigUpdated",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "address",
        "name": "authKey",
        "type": "address"
      }],
      "name": "AccountRecovered",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [],
      "name": "Initialized",
      "type": "event"
    }, {
      "constant": true,
      "inputs": [],
      "name": "getChainId",
      "outputs": [{
        "internalType": "uint256",
        "name": "_result",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "pure",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "isInitialized",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "registry",
      "outputs": [{
        "internalType": "contract AccountRegistry",
        "name": "",
        "type": "address"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address payable",
        "name": "_registry",
        "type": "address"
      }],
      "name": "initialize",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }],
      "name": "getAccountConfig",
      "outputs": [{
        "internalType": "uint256",
        "name": "_nonce",
        "type": "uint256"
      }, {
        "internalType": "address[]",
        "name": "_friends",
        "type": "address[]"
      }, {
        "internalType": "uint256",
        "name": "_requiredFriendSignatures",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address[]",
        "name": "_friends",
        "type": "address[]"
      }, {
        "internalType": "uint256",
        "name": "_requiredFriendSignatures",
        "type": "uint256"
      }],
      "name": "updateAccountConfig",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address[]",
        "name": "_friends",
        "type": "address[]"
      }, {
        "internalType": "bytes",
        "name": "_friendSignatures",
        "type": "bytes"
      }],
      "name": "recoverAccount",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_account",
        "type": "address"
      }, {
        "internalType": "address[]",
        "name": "_friends",
        "type": "address[]"
      }, {
        "internalType": "bytes",
        "name": "_friendSignatures",
        "type": "bytes"
      }, {
        "internalType": "address",
        "name": "_refundToken",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_refundAmount",
        "type": "uint256"
      }, {
        "internalType": "bytes",
        "name": "_signature",
        "type": "bytes"
      }],
      "name": "relayAccountRecovery",
      "outputs": [],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }],
    "addresses": {
      "1": "0x94A63a39dF136cCCE4168D65f3B1EC8Df941A8FB",
      "3": "0x94A63a39dF136cCCE4168D65f3B1EC8Df941A8FB",
      "4": "0x94A63a39dF136cCCE4168D65f3B1EC8Df941A8FB",
      "5": "0x70A40230cCE5F4b0684Bf24b84B3AA612b7D8b65",
      "42": "0x94A63a39dF136cCCE4168D65f3B1EC8Df941A8FB",
      "100": "0x94A63a39dF136cCCE4168D65f3B1EC8Df941A8FB",
      "4660": "0x94A63a39dF136cCCE4168D65f3B1EC8Df941A8FB"
    },
    "byteCodeHash": null
  },
  "ERC20Token": {
    "abi": [{
      "inputs": [{
        "internalType": "string",
        "name": "_name",
        "type": "string"
      }, {
        "internalType": "string",
        "name": "_symbol",
        "type": "string"
      }, {
        "internalType": "uint8",
        "name": "_decimals",
        "type": "uint8"
      }],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "constructor"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }, {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }],
      "name": "Approval",
      "type": "event"
    }, {
      "anonymous": false,
      "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      }, {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }],
      "name": "Transfer",
      "type": "event"
    }, {
      "constant": true,
      "inputs": [],
      "name": "name",
      "outputs": [{
        "internalType": "string",
        "name": "",
        "type": "string"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "symbol",
      "outputs": [{
        "internalType": "string",
        "name": "",
        "type": "string"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "decimals",
      "outputs": [{
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [],
      "name": "totalSupply",
      "outputs": [{
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_owner",
        "type": "address"
      }],
      "name": "balanceOf",
      "outputs": [{
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": true,
      "inputs": [{
        "internalType": "address",
        "name": "_owner",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_spender",
        "type": "address"
      }],
      "name": "allowance",
      "outputs": [{
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_to",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }],
      "name": "transfer",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_from",
        "type": "address"
      }, {
        "internalType": "address",
        "name": "_to",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }],
      "name": "transferFrom",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }, {
      "constant": false,
      "inputs": [{
        "internalType": "address",
        "name": "_spender",
        "type": "address"
      }, {
        "internalType": "uint256",
        "name": "_value",
        "type": "uint256"
      }],
      "name": "approve",
      "outputs": [{
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }],
      "payable": false,
      "stateMutability": "nonpayable",
      "type": "function"
    }],
    "addresses": {},
    "byteCodeHash": null
  }
};